import styled from 'styled-components'
import Colors from 'spartacus/styles/colors'
import Shadows from 'spartacus/styles/shadows'
import Dimensions from 'spartacus/styles/dimensions'

export const ImageContainer = styled.div`
  img {
    width: 80%;
    margin: 0 auto;
  }

  margin-bottom: 4vh;
`

export const Card = styled.div`
  background: ${Colors.UI.White};
  border-radius: 12px;
  box-shadow: ${Shadows.AppFrame};
  padding: 4vh ${Dimensions.nColumns(2)};
  text-align: center;

  form {
    text-align: left;

    > button {
      margin: 4vh 0 0;
    }
  }

  @media ${Dimensions.md} {
    padding: 4vh ${Dimensions.nColumns(2)};
  }

  @media ${Dimensions.lg} {
    padding: 4vh ${Dimensions.nColumns(1)};
  }

  @media ${Dimensions.xl} {
    padding: 4vh ${Dimensions.nColumns(1)};
  }
`
